import { useState, useEffect } from "react";
import moment from "moment";
import { IoEyeOutline } from "react-icons/io5";
import useTranslator from "../../hooks/useTranslator";
import { showTickOnDoc } from "../../helper/common";
import CloseIcon from "../../assets/img/closeIcon.svg";
import FilePreviewModal from "../FilePreviewmodal";

const DocHistoryPopup = ({
  isOpen,
  onClose,
  docName,
  previousUploads = [],
  allData,
  handlePreviewDocument,
  user,
  selectedIndex,
  allForensicDocuments = {},
  currentLang,
}) => {
  const { _t } = useTranslator();
  const [filePreview, showFilePreview] = useState(false);
  const [showIndex, setShowIndex] = useState(null);
  const [innerIndex, setInnerIndex] = useState(null);

  useEffect(() => {
    setShowIndex(selectedIndex);
  }, [selectedIndex]);

  const getCleanFileName = (fileName) => {
    if (!fileName) return "";

    const parts = fileName.split(".");
    const ext = parts.pop(); // get extension
    const nameWithoutExt = parts.join("."); // handle names with multiple dots

    const segments = nameWithoutExt.split("_");
    if (segments.length > 1) {
      segments.pop(); // remove last part after underscore
    }

    const cleanName = segments.join("");

    return `${cleanName}.${ext}`;
  };

  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup ${isOpen ? "open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="drawerIcon" onClick={onClose} />
        <div className="doc-history-header">
          {/* <button className="doc-history-close-btn" onClick={onClose}> */}
          <img
            src={CloseIcon}
            alt=""
            className="doc-history-close-btn"
            onClick={onClose}
          />
          {/* </button> */}
          <h4>
            {/* #NOTE: Heading Name */}
            {_t("documentHistory", "Text used in documeent history popup")}
          </h4>
        </div>

        <div className="d-flex justify-content-between wrapper-date">
          <p className="doc-history-doc-name">
            {/* #NOTE: Document Name */}
            {allForensicDocuments?.[allData?.[selectedIndex]?.file_name]
              ?.documentNameTranslated?.[
              currentLang === "en-us" ? "en" : "es"
            ] ?? _t(docName, "", "fixed")}

            {/* {_t(docName, "", "fixed")} */}
            {allData?.length > 0 &&
              showTickOnDoc(allData[selectedIndex], user) && (
                <img
                  src="/images/tick-new.svg"
                  alt=""
                  className="green-check-icon greenCheck"
                />
              )}
          </p>
        </div>
        {allData?.length > 0 && (
          <p className="doc-history-upload-date uploadDate">
            {/* #NOTE: Upload Date */}
            {_t("uploadedOn")}{" "}
            {moment(allData[selectedIndex]?.created_at).format("DD/MM/YYYY")}
          </p>
        )}
        {/* #NOTE: File Preview */}
        {allData?.length > 0 && (
          <div
            className="videoframe video-frame d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              // setShowIndex(0);
              showFilePreview(true);
            }}
          >
            {allData[selectedIndex]?.file_name?.endsWith(".csv") ? (
              <img
                style={{ objectFit: "contain", margin: "auto" }}
                src="/images/csv-dummy.svg"
                alt=""
              />
            ) : (
              <iframe
                src={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${allData[selectedIndex]?.file_name}`}
                scrolling="no"
                style={{ margin: "auto", pointerEvents: "none" }}
              />
            )}
          </div>
        )}

        {allData?.length > 0 && (
          <p className="doc-history-upload-date text-center">
            {/* {allData[selectedIndex]?.file_name} */}
            {getCleanFileName(allData[selectedIndex]?.file_name)}
          </p>
        )}
        {/* #NOTE: Previous Uploads (History of documents) */}
        <p className="doc-history-uploads-title">
          {_t("previousUploads", "Text used in documeent history popup")}
        </p>
        <div className="doc-history-uploads-section">
          <div className="doc-history-uploads-list">
            {previousUploads?.length > 1 ? (
              previousUploads.slice(1).map((upload, index) => (
                <div className="doc-history-upload-item" key={index}>
                  <p className="one-line-clamp">
                    {getCleanFileName(upload?.file_name ?? "N/A")}
                  </p>
                  <IoEyeOutline
                    className="doc-history-eye-icon"
                    onClick={(e) => {
                      setInnerIndex(index + 1);
                      showFilePreview(true);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <p className="doc-history-upload-date docHistoryUploadDate">
                    {_t("uploadedOn")}{" "}
                    {moment(upload?.created_at).format("DD/MM/YYYY")}
                  </p>
                </div>
              ))
            ) : (
              <p className="doc-history-no-history">
                {_t(
                  "noDocHistoryAvailable",
                  "Text used in documeent history popup"
                )}
              </p>
            )}
          </div>
        </div>
      </div>
      <FilePreviewModal
        show={filePreview}
        onClose={() => {
          setInnerIndex(null);
          setShowIndex(selectedIndex);
          showFilePreview(false);
        }}
        files={innerIndex ? previousUploads : allData}
        showIndex={innerIndex ? innerIndex : showIndex}
      />
    </div>
  );
};

export default DocHistoryPopup;
